var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.1 20c-.15 0-.31-.06-.42-.18a.61.61 0 010-.85L18.45 4.2h-3.5c-.33 0-.6-.27-.6-.6s.27-.6.6-.6h4.897a.619.619 0 01.483.17.577.577 0 01.17.503V8.55c0 .33-.27.6-.6.6s-.6-.27-.6-.6v-3.5L4.53 19.82c-.12.12-.28.18-.43.18zm6.34-9.9L4.52 4.18a.58.58 0 00-.84 0 .58.58 0 000 .84l5.92 5.92zM14.95 21h4.95c.33 0 .6-.27.6-.6v-4.95c0-.33-.27-.6-.6-.6s-.6.27-.6.6v3.51l-5.9-5.9-.84.84 5.9 5.9h-3.51c-.33 0-.6.27-.6.6s.27.6.6.6z",
    fillRule: "evenodd"
  })));
}

export default SvgResize;